import { inject } from "vue";
const NC_FORM_BOX_CONTEXT_KEY = /* @__PURE__ */ Symbol.for("NcFormBox:context");
function useNcFormBox() {
  return inject(NC_FORM_BOX_CONTEXT_KEY, {
    isInFormBox: false,
    formBoxItemClass: void 0
  });
}
export {
  NC_FORM_BOX_CONTEXT_KEY as N,
  useNcFormBox as u
};
//# sourceMappingURL=useNcFormBox.mjs.map
